var PanelPosition;
(function (PanelPosition) {
    PanelPosition["Center"] = "center";
    PanelPosition["Left"] = "left";
    PanelPosition["Right"] = "right";
})(PanelPosition || (PanelPosition = {}));
var DisplayMode;
(function (DisplayMode) {
    DisplayMode["Headband"] = "HEADBAND";
    DisplayMode["Button"] = "BUTTON";
})(DisplayMode || (DisplayMode = {}));

export { DisplayMode, PanelPosition };
//# sourceMappingURL=types.js.map
